import Vue from "vue";
const _this = new Vue();
import axios from 'axios'
import store from '@/store/index.js'
import { getToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'

var timeout, args, context, timestamp, result;
const functions = {
    /**
     * underscore 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
     * @param  {function} func        回调函数
     * @param  {number}   wait        表示时间窗口的间隔
     * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
     * @return {function}             返回客户调用函数
     */
    debounce(func, wait, immediate) {
        var later = function () {
            // 现在和上一次时间戳比较
            var last = new Date().getTime() - timestamp;
            // 如果当前间隔时间少于设定时间且大于0就重新设置定时器
            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                // 否则的话就是时间到了执行回调函数
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                }
            }
        };
        return function () {
            context = _this;
            args = arguments;
            // 获得时间戳
            timestamp = new Date().getTime();
            // 如果定时器不存在且立即执行函数
            var callNow = immediate && !timeout;
            // 如果定时器不存在就创建一个
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) {
                // 如果需要立即执行函数的话 通过 apply 执行
                result = func.apply(context, args);
                context = args = null;
            }
            return result;
        };
    },
    // 公共提示弹框
    commonConfirm() {
        const message = arguments[0], // 主信息
            title = arguments[1] ? arguments[1] : "提示", // 标题
            desc = arguments[2] ? arguments[2] : "", // 描述信息
            successBack = arguments[3], // 成功方法回调
            failBack = arguments[4], // 失败方法回调
            isDelete = arguments[5] || false, // 是否是删除
            nocancel = arguments[6], // 是否没有取消按钮
            confirmText = arguments[7], // 是否没有取消按钮
            cancelText = arguments[8]; // 是否没有取消按钮
        const h = _this.$createElement;
        _this
            .$confirm("", {
                message: h("div", null, [
                    h(
                        "div",
                        {
                            attrs: { class: "confirmMessage" },
                        },
                        [
                            h("img", {
                                style: "width: 20px;height:20px",
                                attrs: {
                                    src: isDelete ? _this.deleteSrc : _this.queicn,
                                },
                            }),
                            h("span", null, message),
                        ]
                    ),
                    desc ? h("p", { class: "confirmDesc" }, desc) : "",
                ]),
                title: title,
                confirmButtonText: confirmText || "确定",
                cancelButtonText: cancelText || "取消",
                customClass: "common_confirm_model",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: nocancel ? false : true,
            })
            .then(successBack)
            .catch(failBack);
    },
    // 公共页面加载遮罩
    commonLoading() {
        const text = arguments[0] || "Loading"; // 遮罩信息
        return _this.$loading({
            lock: true,
            text: text,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    },
    // 下载文件流压缩包
    downloadZipFile(data) {
        let blob = new Blob([data], { type: "application/zip" });
        let url = window.URL.createObjectURL(blob);
        const link = document.createElement("a"); // 创建a标签
        link.href = url;
        link.download = "加粉明细统计导出"; // 重命名文件
        link.click();
    },
    // 下载文件流
    downloadFile(data) {
        try {
            const blob = new Blob([data], {
                type: "application/vnd.ms-excel;charset=utf-8",
            })
            if ('download' in document.createElement('a')) {
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = window.URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.download = '下载表格.xlsx';
                link.click()
                window.URL.revokeObjectURL(link.href)
                document.body.removeChild(link)
            } else {
                navigator.msSaveBlob(blob)
            }
        } catch (e) {
            console.log("下载的文件出错", e);
        }
    },
    // 通过图片网址 直接下载
    downloadImgByUrl(imgsrc, name) {
        //下载图片地址和图片名
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = () => {
            let canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
            let a = document.createElement("a"); // 生成一个a元素
            let event = new MouseEvent("click"); // 创建一个单击事件
            a.download = name; // 设置图片名称
            a.href = url; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
    },
    // 通过文件网址 直接下载
    downloadFileByUrl(url, name) {
        let a = document.createElement("a"); // 生成一个a元素
        a.href = url; // 将生成的URL设置为a.href属性
        a.download = name; // 设置文件名称
        a.click();
        a.remove();
    },
    // 设置下拉框最多可输入字符长度
    setSelectMaxLength(dom, length) {
        document.querySelector(dom) &&
        document.querySelector(dom).setAttribute("maxLength", length);
    },
    // 包括整数位指定长度，小数位最多两位数
    verifyFloat(obj, property, length) {
        // 保证第一位数不是 “.”
        obj[property] = obj[property].replace(/^\./g, "");
        // 只能输入数字和小数和点
        obj[property] = obj[property].replace(/[^\d^.]+/g, "");
        // 只保留一个小数点
        obj[property] = obj[property].replace(/\.{2,}/g, ".");
        obj[property] = obj[property]
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".");
        // 只保留两位小数
        obj[property] = obj[property].replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        const arr = obj[property].split(".");
        if (arr.length == 1) {
            // 只有整数
            obj[property] = arr[0].substr(0, length);
            // 排除首位是0的情况
            if (obj[property].length >= 2) {
                // 防止输入多个0
                if (obj[property] == "00") {
                    obj[property] = "";
                } else if (obj[property].substr(0, 1) == "0") {
                    obj[property] = arr[0].substr(1, length);
                }
            }
        } else {
            // 有小数
            const arr1 = obj[property].split(".");
            // 整数位
            let first = arr1[0].substr(0, length);
            // 排除首位是0的情况
            if (first.length >= 2) {
                // 防止输入多个0
                if (first == "00") {
                    first = "";
                } else if (first.substr(0, 1) == "0") {
                    first = arr1[0].substr(1, length);
                }
            }
            obj[property] = first + "." + arr1[1];
        }
    },

    // 不会自动填0
    verifyNot0(obj, property, length) {
        // 保证第一位数不是 “.”
        obj[property] = obj[property].replace(/^\./g, "");

        // 只能输入数字和小数和点
        obj[property] = obj[property].replace(/[^\d^.]+/g, "");
        // 只保留一个小数点
        obj[property] = obj[property].replace(/\.{2,}/g, ".");
        obj[property] = obj[property]
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".");
        // 只保留两位小数
        obj[property] = obj[property].replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        const arr = obj[property].split(".");
        if (arr.length == 1) {
            // 只有整数
            obj[property] = arr[0].substr(0, length);
            if (obj[property].length >= 2) {
                if (obj[property] == "00") {
                    obj[property] = "";
                } else if (obj[property].substr(0, 1) == "0") {
                    obj[property] = arr[0].substr(1, length);
                }
            }

            // 排除首位是0的情况
        } else {
            // 有小数
            obj[property] = arr[0].substr(0, length) + "." + arr[1];
        }
    },
    // 只能输入整数(能0开头)
    verifyInt(row, e) {
        row[e] = row[e].replace(/\D/g, "");
    },
    // 只能输入整数(不能0开头)
    verifyNum(obj, property) {
        obj[property] = obj[property].replace(/^0/g, "");
        if (obj[property] == "00") {
            obj[property] = "";
        }
        obj[property] = obj[property].replace(/\D/g, "");
    },
    // 只能输入数字和-
    verifyNumLine(obj, property) {
        obj[property] = obj[property].replace(/[^0-9-]*/g, "");
    },
    // 只能输入数字和英文
    verifyLetterNum(obj, property) {
        obj[property] = obj[property].replace(/[^0-9a-zA-Z]/g, "");
    },
    // 只能输入数字 英文 - _
    verifyLetterNumLine(obj, property) {
        obj[property] = obj[property].replace(/[^0-9a-zA-Z-_]/g, "");
    },
    //只能输入数字和中文
    verifyChineseNum(obj, property) {
        obj[property] = obj[property].replace(/[^0-9\u4e00-\u9fa5]/g, "");
    },
    //只能输入中文
    verifyChinese(obj, property) {
        obj[property] = obj[property].replace(/[^\u4e00-\u9fa5]/g, "");
    },
    // 只能输入中英文
    verifyChineseLetter(obj, property) {
        obj[property] = obj[property].replace(/[^a-zA-Z\u4e00-\u9fa5]/g, "");
    },
    // 只能输入英文
    verifyLetter(obj, property) {
        obj[property] = obj[property].replace(/[^a-zA-Z]/g, "");
    },
    // 只能输入中英文和数字
    verifyChineseLetterNum(obj, property) {
        obj[property] = obj[property].replace(/[^0-9a-zA-Z\u4e00-\u9fa5]/g, "");
    },
    // 不能输入中文
    verifyUnChinese(obj, property) {
        obj[property] = obj[property].replace(/[\u4e00-\u9fa5]/g, "");
    },

    /**
     * 字符串中是否存在特殊字符
     * 存在返回true
     * @param str
     * @retun boolean
     */
    hasSpecialStr(str) {
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        var specialChars =
            "~·`!！@#$￥%^…&*()（）—-_=+[]{}【】、|\\;:；：'\"“‘,./<>《》?？，。";
        var len = specialChars.length;
        for (var i = 0; i < len; i++) {
            if (str.indexOf(specialChars.substring(i, i + 1)) != -1) {
                return true;
            }
            if (reg.test(str)) {
                return true;
            }
        }
        return false;
    },
    // 获取当前时间范围
    currentRangeDate() {
        const date = new Date();
        let y, m, d;
        y = date.getFullYear();
        m =
            date.getMonth() + 1 > 9
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1);
        d = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
        return [
            y + "-" + m + "-" + d + " 00:00:00",
            y + "-" + m + "-" + d + " 23:59:59",
        ];
    },
    imgFilter(val) {
        if (val) {
            if (val.includes('data:')) return val
            if (val.length > 100) return val
            val = val.substr(0, 4) == "http" ? val : _this.imageIp + val
            if (val) {
                val = val.replace('img.godear.net', 'mw.tushu.cloud')
            }
        } else {
            val = _this.noImg
        }
        return val;
    },
    downloadHandle(data, url, name, method) {
        showScreenLoading()
        const json = {
            method: method || 'post',
            url: url,
            responseType: 'blob',
            data,
            headers: {
                Authorization: getToken() || '',
                Appid: store.state.user.appid
            }
        }
        method == 'get' && (json.params = data);
        axios(json)
            .then(async (res) => {
                hideScreenLoading()
                let data = res.data
                let url = window.URL.createObjectURL(new Blob([data]))
                let a = document.createElement('a')
                a.style.display = 'none'
                a.href = url
                let filename = `${name}.xlsx`
                a.setAttribute('download', decodeURIComponent(filename))
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(a.href)
                document.body.removeChild(a)
            })
            .catch(() => {
                hideScreenLoading()
            })
    },
    objClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};

export default functions;
